import { render, staticRenderFns } from "./ChangeAccountStatusBtn.vue?vue&type=template&id=1601d852&"
import script from "./ChangeAccountStatusBtn.vue?vue&type=script&lang=js&"
export * from "./ChangeAccountStatusBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports